const validate = (values) => {
  const attrs = values || {};
  const errors = {};

  if (!attrs.alumno || !attrs.alumno.value) {
    errors.alumno = 'Debe seleccionar el alumno';
  }
  if (!attrs.malla || !attrs.malla.value) {
    errors.malla = 'Debe seleccionar la malla';
  }
  if (!attrs.semestre || !attrs.semestre.value) {
    errors.semestre = 'Debe ingresar un semestre';
  }
  if (!attrs.materia || !attrs.materia.value) {
    errors.materia = 'Debe ingresar una materia';
  }

  return errors;
};

export default validate;
